import React from "react";
import PropTypes from "prop-types";

// styled components
import { IconButtonWrapper, IconButtonInner, IconButtonIcon, IconButtonLabel, IconButtonLink } from "./IconButton.styled";

const Error = ({ iconCls, label, href }) => {
    return (
        <IconButtonWrapper>
            <IconButtonInner>
                <IconButtonIcon className={`icon ${iconCls}`}></IconButtonIcon>
                <IconButtonLabel>{label}</IconButtonLabel>
                <IconButtonLink href={href} aria-label={label} className="card-link gtm-cta">
                    {label}
                </IconButtonLink>
            </IconButtonInner>
        </IconButtonWrapper>
    );
};

// props validation
Error.propTypes = {
    iconCls: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired
};

export default Error;
